export default "__VITE_ASSET__815f877f__"